import axios from "axios";
export const BASE_URL = "https://demo.hamropalika.org";
export const baseURLAPI = "https://demo.hamropalika.org/api";
export default axios.create({
    baseURL: `${BASE_URL}/api/website/cache/`,
});
